import {SimpleGridDataComponent} from "./simple-grid-data.component";
import {SimpleGridTableComponent} from "./simple-grid-table.component";
import {SimpleGridSortableHeaderComponent} from "./simple-grid-sortable-header.component";
import {SimpleGridRecordComponent} from "./simple-grid-record.component";
import {SimpleGridDataImage} from "./SimpleGridDataImage";
import {SimpleGridDataCurrency} from "./SimpleGridDataCurrency";
import {SimpleGridDataChecksComponent} from "./simple-grid-data-checks.component";
import {SimpleGridDataDropdownComponent} from "./simple-grid-data-dropdown.component";
import {NgModule, ModuleWithProviders} from "@angular/core";
import {CommonModule} from "@angular/common";
import {
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
// import {StoreModel} from "../../models/StoreModel";


export const SIMPLEGRID_DIRECTIVES: Array<any> = [SimpleGridTableComponent, SimpleGridSortableHeaderComponent, SimpleGridRecordComponent, SimpleGridDataComponent, SimpleGridDataCurrency, SimpleGridDataImage, SimpleGridDataChecksComponent, SimpleGridDataDropdownComponent];

export interface ISimpleGridEdit {
  value: string;
  item: any;
}

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatIconModule],
  declarations: SIMPLEGRID_DIRECTIVES,
  exports: SIMPLEGRID_DIRECTIVES
})

// here we are loading the providers ONLY when this shared module is loaded by the app and not
// by a feature or lazy loaded module, this making sure we share a single instance of AuthService
export class SimpleGridModule {
  static forRoot(): ModuleWithProviders<SimpleGridModule> {
    return {
      ngModule: SimpleGridModule,
      providers: []
    };
  }
}
